import React, {useCallback, useEffect, useState} from "react";
import {AnalyticsTracking} from "../../components/AnalyticsTracking/AnalyticsTracking";
import MailBox from "./MailBox";
import MailBoxAuthPage from "./MailBoxAuthPage";
import RestClientInstance from "../../../../lib/RestClient";
import LoadingContainer from "../../containers/LoadingContainer/LoadingContainer";

interface MailBoxPageContainerProps {

}

type AuthState = 'unknown' | 'authenticated' | 'unauthenticated';

function MailBoxPage(props: MailBoxPageContainerProps) {
  const [authState, setAuthState] = useState<AuthState>('unknown');

  const [isInitialized, setIsInitialiezd] = useState<boolean>(false);
  const [authToken, setAuthToken] = useState<string>('');

  const checkAuth = useCallback(() =>{
    RestClientInstance.get('mailbox/auth/status', {
      token: authToken
      })
      .then(response => {
        // check response and see if status needs update.
        setIsInitialiezd(response.data.initialized);

        if(response.data.authenticated) {
          setAuthState('authenticated');
        } else {
          setAuthState('unauthenticated');
        }
      }).catch(error => {
        // handled by framework
      });
  }, [authToken]);

  const onAuthenticate = useCallback(token => {
    setAuthToken(token);
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  useEffect(() => {
    const intervalId = setInterval(checkAuth, 60000);
    return () => {
      clearInterval(intervalId);
    }
  }, [checkAuth]);

  useEffect(() => {
    // check auth state, simulate for now
    setTimeout(() => {
      setAuthState('unauthenticated');
    }, 500);
  }, []);

  return <>
    <AnalyticsTracking page="mailbox" />
    {authState === 'unknown' && <LoadingContainer showLogo={false}/>}
    {authState === 'authenticated' && <MailBox authToken={authToken} />}
    {authState === 'unauthenticated' && <MailBoxAuthPage isInitialized={isInitialized} onAuthenticated={onAuthenticate} />}
  </>
}

export default MailBoxPage;